<template>
  <div @click="onClick">
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.docfis_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.docfis_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Partes Env.
              <i class="fa fa-users"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_produto"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Produtos
              <i class="fa fa-archive"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_veiculo"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Veículos
              <i class="fa fa-car"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_adicional"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Sefaz
              <i class="fa fa-user"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.docfis_id + ''"
            v-if="
              rowData.doc_fiscal_produto.length > 0 &&
              rowData.doc_fiscal_produto[0].doc_fiscal_importacao
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Adições
              <i class="fa fa-plus-square"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.docfis_id + ''"
            v-if="
              rowData.doc_fiscal_produto.length > 0 &&
              rowData.doc_fiscal_produto[0].doc_fiscal_armamento.length > 0
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Armamento
              <i class="fa fa-bullseye"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t8' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_safra"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Safra
              <i class="fa fa-pagelines"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t9' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_cobranca"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Cobrança
              <i class="fa fa-envelope"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t10' + rowData.docfis_id + ''"
            v-if="
              rowData.doc_fiscal_produto.length > 0 &&
              rowData.doc_fiscal_produto[0].doc_fiscal_combustivel.length > 0
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Combustível
              <i class="fa fa-fire"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t11' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_comex"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Comex
              <i class="fa fa-globe"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t12' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_compra"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Compra
              <i class="fa fa-shopping-cart"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t13' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_duplicata.length > 0"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Duplicata
              <i class="fa fa-copy"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t14' + rowData.docfis_id + ''"
            v-if="
              rowData.doc_fiscal_produto.length > 0 &&
              rowData.doc_fiscal_produto[0].doc_fiscal_exportacao.length > 0
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Exportação
              <i class="fa fa-share-square"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t15' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_info_adicional"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Informações Adicionais
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t16' + rowData.docfis_id + ''"
            v-if="
              rowData.doc_fiscal_produto.length > 0 &&
              rowData.doc_fiscal_produto[0].doc_fiscal_medicamento.length > 0
            "
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Medicamento
              <i class="fa fa-pills"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t17' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_referenciado"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Referenciado
              <i class="fa fa-user"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t18' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_uso_livre"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Uso Livre
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t19' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_imposto"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Imposto
              <i class="fa fa-envelope"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t20' + rowData.docfis_id + ''"
            v-if="rowData.doc_fiscal_transporte"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Transporte
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              v-bind:href="'#t21' + rowData.docfis_id + ''"
              role="tab"
              data-toggle="tab"
              v-if="
              rowData.doc_fiscal_log.length > 0
            "
          >
            <span class="nav-link-in">
              Erros
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              v-bind:href="'#t22' + rowData.docfis_id + ''"
              role="tab"
              data-toggle="tab"
              v-if="
              rowData.usuario_id_ocultar
            "
          >
            <span class="nav-link-in">
              Ocultar
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.docfis_id + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">UF:</th>
                <th style="width: 20%">Chave</th>
                <th style="width: 15%">NOP</th>
                <th style="width: 10%">Tipo Operação</th>
                <th style="width: 10%">Tipo Emissão</th>
                <th style="width: 10%">Digito Verificador</th>
                <th style="width: 5%">Ambiente</th>
                <th style="width: 10%">DT Saida Entrada</th>
                <th style="width: 10%">HR Saida Entrada</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.uf">{{ rowData.uf.nome }}</span>
                </td>
                <td>
                  {{ rowData.chave }}
                </td>
                <td>
                  {{ rowData.nop }}
                </td>
                <td>
                  {{ rowData.liv_tp_operacao.descr }}
                </td>
                <td>
                  {{ rowData.liv_tp_emissao.descr }}
                </td>
                <td>
                  {{ rowData.digito_verificador }}
                </td>
                <td>
                  {{ rowData.liv_tp_ambiente.descr }}
                </td>
                <td>
                  {{ formatDate(rowData.dt_saida_entrada) }}
                </td>
                <td>
                  {{ formatDate(rowData.hr_saida_entrada) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_partes_env"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%"></th>
                <th data-toggle="true" style="width: 10%">CNPJ / CPF</th>
                <th data-toggle="true" style="width: 10%">Nome</th>
                <th data-toggle="true" style="width: 15%">Endereço</th>
                <th data-toggle="true" style="width: 12%">Bairro</th>
                <th data-toggle="true" style="width: 10%">CEP</th>
                <th data-toggle="true" style="width: 10%">Município</th>
                <th data-toggle="true" style="width: 3%">Estado</th>
                <th data-toggle="true" style="width: 10%">Email</th>
                <th data-toggle="true" style="width: 10%">Telefone</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.emi_endereco"
              >
                <td>
                  <span class="badge badge-secondary">Emitente</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.emi_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.emi_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.emi_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.emi_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_cep">{{
                    rowData.doc_fiscal_partes_env.emi_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.emi_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_email">{{
                    rowData.doc_fiscal_partes_env.emi_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.emi_telefone">{{
                    rowData.doc_fiscal_partes_env.emi_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.rem_endereco"
              >
                <td>
                  <span class="badge badge-warning">Remetente</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rem_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.rem_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.rem_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.rem_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rem_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rem_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.rem_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.rem_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rem_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rem_cep">{{
                    rowData.doc_fiscal_partes_env.rem_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rem_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rem_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rem_email">{{
                    rowData.doc_fiscal_partes_env.rem_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rem_telefone">{{
                    rowData.doc_fiscal_partes_env.rem_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.exp_endereco"
              >
                <td>
                  <span class="badge badge-info">Expedidor</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.exp_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.exp_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.exp_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.exp_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.exp_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.exp_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.exp_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.exp_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.exp_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.exp_cep">{{
                    rowData.doc_fiscal_partes_env.exp_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.exp_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.exp_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.exp_email">{{
                    rowData.doc_fiscal_partes_env.exp_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.exp_telefone">{{
                    rowData.doc_fiscal_partes_env.exp_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.des_endereco"
              >
                <td>
                  <span class="badge badge-success">Destinatário</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.des_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.des_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.des_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.des_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.des_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.des_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.des_cep">{{
                    rowData.doc_fiscal_partes_env.des_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.des_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.des_email">{{
                    rowData.doc_fiscal_partes_env.des_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.des_telefone">{{
                    rowData.doc_fiscal_partes_env.des_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.rec_endereco"
              >
                <td>
                  <span class="badge badge-danger">Recebedor</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rec_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.rec_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.rec_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.rec_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rec_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rec_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.rec_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.rec_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rec_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rec_cep">{{
                    rowData.doc_fiscal_partes_env.rec_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rec_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.rec_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rec_email">{{
                    rowData.doc_fiscal_partes_env.rec_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.rec_telefone">{{
                    rowData.doc_fiscal_partes_env.rec_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.tom_endereco"
              >
                <td>
                  <span class="badge badge-primary">Tomador</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.tom_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.tom_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.tom_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.tom_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.tom_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.tom_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.tom_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_cep">{{
                    rowData.doc_fiscal_partes_env.tom_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.tom_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.tom_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_email">{{
                    rowData.doc_fiscal_partes_env.tom_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.tom_telefone">{{
                    rowData.doc_fiscal_partes_env.tom_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_fiscal_partes_env.red_endereco"
              >
                <td>
                  <span class="badge badge-dark">Redespacho</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.red_cnpj != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.red_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_fiscal_partes_env.red_cpf != null">{{
                    ajustaMascara(rowData.doc_fiscal_partes_env.red_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.red_nome }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.red_endereco }} -
                  {{ rowData.doc_fiscal_partes_env.red_complemento }} -
                  {{ rowData.doc_fiscal_partes_env.red_numero }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.red_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.red_cep">{{
                    rowData.doc_fiscal_partes_env.red_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.red_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_partes_env.red_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.red_email">{{
                    rowData.doc_fiscal_partes_env.red_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_fiscal_partes_env.red_telefone">{{
                    rowData.doc_fiscal_partes_env.red_telefone
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_produto"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Código</th>
                <th style="width: 10%">Descrição</th>
                <th style="width: 10%">NCM</th>
                <th style="width: 5%">CFOP</th>
                <th style="width: 10%">Unidade Comercial</th>
                <th style="width: 5%">Quantidade Comercial</th>
                <th style="width: 10%">Valor Tributário</th>
                <th style="width: 10%">Valor Bruto</th>
                <th style="width: 10%">Unidade Tributável</th>
                <th style="width: 10%">Quantidade Tributável</th>
                <th style="width: 10%">Valor Unitário da Tributação</th>
                <th style="width: 5%">Tipo Carga</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_produto"
              >
                <td>
                  {{ item.cd_produto }}
                </td>
                <td>
                  {{ item.descr_produto }}
                </td>
                <td>
                  {{ item.ncm }}
                </td>
                <td>
                  {{ item.cfop }}
                </td>
                <td>
                  {{ item.unidade_comercial }}
                </td>
                <td>
                  {{ item.qtd_comercial }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_unitario) }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_bruto) }}
                </td>
                <td>
                  {{ item.unidade_tributavel }}
                </td>
                <td>
                  {{ item.qtd_tributavel }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_unitario_tributacao) }}
                </td>
                <td>
                  {{ rowData.tipo_carga.descr }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t4' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_veiculo"
        >
          <div>
            <table class="table-striped" id="mais">
              <thead>
                <tr>
                  <th style="width: 10%">Chassi</th>
                  <th style="width: 10%">Código Cor</th>
                  <th style="width: 10%">Descrição da Cor</th>
                  <th style="width: 10%">Ano do modelo</th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    {{ rowData.doc_fiscal_veiculo.chassi }}
                  </td>
                  <td>
                    {{ rowData.doc_fiscal_veiculo.cd_cor }}
                  </td>
                  <td>
                    {{ rowData.doc_fiscal_veiculo.descricao_cor }}
                  </td>
                  <td>
                    {{ rowData.doc_fiscal_veiculo.ano_modelo_fabricacao }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--.tab-pane-->
        </div>
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_adicional"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Código Aleatório</th>
                <th data-toggle="true" style="width: 5%">Hora Recebimento</th>
                <th data-toggle="true" style="width: 25%">Dígito</th>
                <th data-toggle="true" style="width: 5%">Forma de Pagamento</th>
                <th data-toggle="true" style="width: 5%">Modelo</th>
                <th data-toggle="true" style="width: 20%">Motivo</th>
                <th data-toggle="true" style="width: 20%">Número Protocolo</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.cd_aleatorio }}</span>
                </td>
                <td>
                  <span>{{
                    formatDate(rowData.doc_fiscal_adicional.dh_recebto)
                  }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.digval }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_fiscal_adicional.forma_pagamento
                  }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_fiscal_adicional.modelo_documento_fiscal
                  }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.motivo }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.num_protocolo }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Finalidade</th>
                <th data-toggle="true" style="width: 20%">Emissão NFE</th>
                <th data-toggle="true" style="width: 20%">Tipo Impressão</th>
                <th data-toggle="true" style="width: 20%">
                  Versão Emissao NFE
                </th>
                <th data-toggle="true" style="width: 20%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.finalidade_nfe }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_fiscal_adicional.processo_emissao_nfe
                  }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.tipo_impressao }}</span>
                </td>
                <td>
                  <span>{{ rowData.doc_fiscal_adicional.status }}</span>
                </td>
                <td>
                  <span>{{
                    rowData.doc_fiscal_adicional.versao_processo_emissao_nfe
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + rowData.docfis_id + ''"
          v-if="
            rowData.doc_fiscal_produto.length > 0 &&
            rowData.doc_fiscal_produto[0].doc_fiscal_importacao
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Código Fabricante</th>
                <th style="width: 20%">Número Adição</th>
                <th style="width: 20%">Número Ato Consessório</th>
                <th style="width: 20%">Número Item</th>
                <th style="width: 20%">Desconto</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_produto"
              >
                <td>
                  {{
                    item.doc_fiscal_importacao.doc_fiscal_adicoes
                      .cd_fabricante_estrangeiro
                  }}
                </td>
                <td>
                  {{ item.doc_fiscal_importacao.doc_fiscal_adicoes.num_adicao }}
                </td>
                <td>
                  {{
                    item.doc_fiscal_importacao.doc_fiscal_adicoes
                      .num_ato_consessorio
                  }}
                </td>
                <td>
                  {{
                    item.doc_fiscal_importacao.doc_fiscal_adicoes
                      .num_item_sequencial
                  }}
                </td>
                <td>
                  {{
                    item.doc_fiscal_importacao.doc_fiscal_adicoes
                      .vlr_desconto_item_di
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t7' + rowData.docfis_id + ''"
          v-if="
            rowData.doc_fiscal_produto.length > 0 &&
            rowData.doc_fiscal_produto[0].doc_fiscal_armamento.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 40%">Descrição</th>
                <th style="width: 20%">Tipo</th>
                <th style="width: 20%">Série Arma</th>
                <th style="width: 20%">Série Cano</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_produto[0]
                  .doc_fiscal_armamento.length > 0"
              >
                <td>
                  {{ item.descr_completa }}
                </td>
                <td>
                  {{ item.tipo_arma_fogo }}
                </td>
                <td>
                  {{ item.num_serie_arma }}
                </td>
                <td>
                  {{ item.num_serie_cano }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_safra"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Safra</th>
                <th style="width: 5%">Data</th>
                <th style="width: 10%">Descrição Dedução</th>
                <th style="width: 10%">Valor Dedução</th>
                <th style="width: 10%">Valor Total Dedução</th>
                <th style="width: 10%">Valor Fornecimento</th>
                <th style="width: 10%">Valor Liquido Fornecimento</th>
                <th style="width: 10%">Quantidade</th>
                <th style="width: 10%">Quantidade Anterior</th>
                <th style="width: 10%">Quantidade Geral</th>
                <th style="width: 10%">Quantidade Mês</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_safra.ident_safra }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_safra.mes_ano_ref }}/{{
                    rowData.doc_fiscal_safra.doc_fiscal_cana_diario.dia
                  }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_safra.doc_fiscal_cana_deducoes.descr }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_deducoes
                        .vlr_deducao
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_deducoes
                        .vlr_total_deducao
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_deducoes
                        .vlr_fornecimento
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_deducoes
                        .vlr_liquido_fornecimento
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_diario.qtd
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_diario
                        .qtd_total_anterior
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_diario
                        .qtd_total_geral
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_safra.doc_fiscal_cana_diario
                        .qtd_total_mes
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_cobranca"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 40%">Número da Fatura</th>
                <th style="width: 20%">Valor do desconto</th>
                <th style="width: 20%">Valor líquido</th>
                <th style="width: 20%">Valor Original da Fatura</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_cobranca.num_fatura }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_cobranca.vlr_desconto) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_cobranca.vlr_liquido) }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_cobranca.vlr_original_fatura
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t10' + rowData.docfis_id + ''"
          v-if="
            rowData.doc_fiscal_produto.length > 0 &&
            rowData.doc_fiscal_produto[0].doc_fiscal_combustivel
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 40%">Código ANP</th>
                <th style="width: 20%">CODIF</th>
                <th style="width: 20%">Quantidade Faturada</th>
                <th style="width: 20%">UF Consumo</th>
                <th style="width: 20%">Valor BC Cide</th>
                <th style="width: 20%">Alíquota Cide</th>
                <th style="width: 20%">Valor Cide</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_produto[0]
                  .doc_fiscal_combustivel"
              >
                <td>
                  {{ item.cd_anp }}
                </td>
                <td>
                  {{ item.codif }}
                </td>
                <td>
                  {{ formatNumber(item.qtd_fat) }}
                </td>
                <td>
                  {{ item.uf_consumo }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_consumo) }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_bc_cide) }}
                </td>
                <td>
                  {{ formatNumber(item.alq_cide) }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_cide) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t11' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_comex"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 100%">Local de Embarque</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_comex.uf_embarque }} -
                  {{ rowData.doc_fiscal_comex.local_embarque }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t12' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_compra"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Nota Empenho</th>
                <th style="width: 40%">Pedido</th>
                <th style="width: 40%">Contrato</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_compra.nota_empenho }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_compra.pedido }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_compra.contrato }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t13' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_duplicata"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Número</th>
                <th style="width: 40%">Valor</th>
                <th style="width: 40%">Data de Vencimento</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_duplicata"
              >
                <td>
                  {{ item.num_duplicata }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_duplicata) }}
                </td>
                <td>
                  {{ formatDate(item.dt_vencimento) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t14' + rowData.docfis_id + ''"
          v-if="
            rowData.doc_fiscal_produto.length > 0 &&
            rowData.doc_fiscal_produto[0].doc_fiscal_exportacao.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Número Ato Consessório</th>
                <th
                  v-if="
                    rowData.doc_fiscal_produto.length > 0 &&
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe !== null
                  "
                  style="width: 40%"
                >
                  Chave NFE
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_produto.length > 0 &&
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe !== null
                  "
                  style="width: 20%"
                >
                  Número Registro Exportação
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_produto.length > 0 &&
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe !== null
                  "
                  style="width: 20%"
                >
                  Quantidade Exportada
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_produto[0]
                  .doc_fiscal_exportacao"
              >
                <td>
                  {{ item.num_ato_concessorio }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_produto.length > 0 &&
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe !== null
                  "
                >
                  {{
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe.chave_nfe
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_produto.length > 0 &&
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe !== null
                  "
                >
                  {{
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe.num_registro_exportacao
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_produto.length > 0 &&
                    rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                      .doc_fiscal_exportacao_detalhe !== null
                  "
                >
                  {{
                    formatNumber(
                      rowData.doc_fiscal_produto[0].doc_fiscal_exportacao[0]
                        .doc_fiscal_exportacao_detalhe.qtde_item_exportado
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t15' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_info_adicional"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Contrato</th>
                <th style="width: 50%">Fisco</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{
                    rowData.doc_fiscal_info_adicional
                      .info_adicional_interesse_contr
                  }}
                </td>
                <td>
                  {{
                    rowData.doc_fiscal_info_adicional
                      .info_adicional_interesse_fisco
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Origem Processo</th>
                <th style="width: 50%">Identificador</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{
                    rowData.doc_fiscal_info_adicional.doc_fiscal_processo
                      .indicador_origem_processo
                  }}
                </td>
                <td>
                  {{
                    rowData.doc_fiscal_info_adicional.doc_fiscal_processo
                      .identificador_processo
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">X Campo</th>
                <th style="width: 50%">X Texto</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{
                    rowData.doc_fiscal_info_adicional.doc_fiscal_uso_livre_fisco
                      .xcampo
                  }}
                </td>
                <td>
                  {{
                    rowData.doc_fiscal_info_adicional.doc_fiscal_uso_livre_fisco
                      .xtexto
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t16' + rowData.docfis_id + ''"
          v-if="
            rowData.doc_fiscal_produto.length > 0 &&
            rowData.doc_fiscal_produto[0].doc_fiscal_medicamento
          "
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Lote</th>
                <th style="width: 40%">Quantidade</th>
                <th style="width: 40%">Valor</th>
                <th style="width: 40%">Fabricação</th>
                <th style="width: 40%">Validade</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_produto[0]
                  .doc_fiscal_medicamento"
              >
                <td>
                  {{ item.num_lote }}
                </td>
                <td>
                  {{ formatNumber(item.qtde_produto_lote) }}
                </td>
                <td>
                  {{ formatNumber(item.vlr_max_consumidor) }}
                </td>
                <td>
                  {{ formatDate(item.dt_fabricacao) }}
                </td>
                <td>
                  {{ formatDate(item.dt_validade) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t17' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_referenciado"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 15%">Chave</th>
                <th style="width: 15%">Chave CTE</th>
                <th style="width: 10%">CNPJ</th>
                <th style="width: 10%">CPF</th>
                <th style="width: 5%">IE</th>
                <th style="width: 5%">Modelo</th>
                <th style="width: 10%">Número Coo</th>
                <th style="width: 10%">Número Doc</th>
                <th style="width: 5%">Número Sequencial</th>
                <th style="width: 5%">Série</th>
                <th style="width: 5%">Tipo Doc</th>
                <th style="width: 5%">UF</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_referenciado.chave }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.chave_cte }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.cnpj }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.cpf }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.ie }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.modelo_doc_fiscal }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.num_coo }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.num_doc }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.num_sequencial_ecf }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.serie }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.tipo_doc_referenciado }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_referenciado.uf }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t18' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_uso_livre"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">X Campo Livre</th>
                <th style="width: 40%">X Texto Livre</th>
                <th style="width: 40%">X Campo Fisco</th>
                <th style="width: 40%">X Texto Fisco</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_uso_livre.xcampo }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_uso_livre.xtexto }}
                </td>
                <td>
                  {{
                    rowData.doc_fiscal_uso_livre.doc_fiscal_uso_livre_fisco
                      .xcampo
                  }}
                </td>
                <td>
                  {{
                    rowData.doc_fiscal_uso_livre.doc_fiscal_uso_livre_fisco
                      .xtexto
                  }}
                </td>
                <td>
                  {{ formatDate(item.dt_validade) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t19' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_imposto"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">CST</th>
                <th style="width: 15%">Origem Mercadoria</th>
                <th style="width: 30%">Modalidade</th>
                <th style="width: 20%">Valor BC ICMS</th>
                <th style="width: 5%">Alíquota</th>
                <th style="width: 5%">Alíquota Redução</th>
                <th style="width: 20%">Valor ICMS</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_imposto.cst }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto.origem_mercadoria }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto.modalidade_bc_icms }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.vlr_icms) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.alq) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.alq_reducao_bc) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.vlr_bc_icms) }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Modalidade ST</th>
                <th style="width: 10%">Valor BC ICMS ST</th>
                <th style="width: 5%">Alíquota ST</th>
                <th style="width: 5%">Alíquota Redução ST</th>
                <th style="width: 10%">Valor ICMS ST</th>
                <th style="width: 10%">Valor ICMS ST Retido</th>
                <th style="width: 10%">Valor BC ICMS ST Retido</th>
                <th style="width: 5%">UF Devido ICMS ST</th>
                <th style="width: 10%">Valor BC ICMS ST Retido UF Remetente</th>
                <th style="width: 10%">
                  Valor BC ICMS ST Retido UF Destinátario
                </th>
                <th style="width: 10%">Valor ICMS ST Retido UF Remetente</th>
                <th style="width: 10%">Valor ICMS ST Retido UF Destinátario</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_imposto.modaliade_bc_st }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.vlr_bc_icms_st) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.alq_st) }}
                </td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto.alq_reducao_bc_st)
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto.vlr_icms_st) }}
                </td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto.vlr_icms_st_retido)
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto.vlr_bc_icms_st_retido
                    )
                  }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto.uf_devido_icms_st }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto.vlr_bc_icms_st_retido_uf_rem
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto.vlr_bc_icms_st_retido_uf_dest
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto.vlr_icms_st_retido_uf_rem
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto.vlr_icms_st_retido_uf_dest
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_fiscal_imposto_cofins"
          >
            <thead>
              <tr>
                <th style="width: 10%">Cofins</th>
                <th style="width: 5%">CST</th>
                <th style="width: 10%">Alíquota</th>
                <th style="width: 5%">Alíquota Reais</th>
                <th style="width: 5%">Alíquota Reais ST</th>
                <th style="width: 5%">Alíquota ST</th>
                <th style="width: 10%">Quantidade Vendida</th>
                <th style="width: 10%">Quantidade Vendida ST</th>
                <th style="width: 10%">Valor</th>
                <th style="width: 10%">Valor BC</th>
                <th style="width: 10%">Valor BC ST</th>
                <th style="width: 10%">Valor ST</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td></td>
                <td>
                  {{ rowData.doc_fiscal_imposto_cofins.cst }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_cofins.alq) }}
                </td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto_cofins.alq_reais)
                  }}
                </td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto_cofins.alq_reais_st)
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_cofins.alq_st) }}
                </td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto_cofins.qtd_vendida)
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto_cofins.qtd_vendida_st
                    )
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_cofins.vlr) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_cofins.vlr_bc) }}
                </td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto_cofins.vlr_bc_st)
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_cofins.vlr_st) }}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_fiscal_imposto_ipi"
          >
            <thead>
              <tr>
                <th style="width: 10%">IPI</th>
                <th style="width: 5%">CST</th>
                <th style="width: 10%">Alíquota</th>
                <th style="width: 5%">Código Enquadramento</th>
                <th style="width: 5%">CNPJ Produtor</th>
                <th style="width: 5%">Selo</th>
                <th style="width: 10%">Quantidade Selo</th>
                <th style="width: 10%">Quantidade Total Tributação</th>
                <th style="width: 10%">Valor</th>
                <th style="width: 20%">Valor BC</th>
                <th style="width: 10%">Valor Unidade Tributária</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td></td>
                <td>
                  {{ rowData.doc_fiscal_imposto_ipi.cst }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_ipi.aliquota) }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto_ipi.cd_enquadramento }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto_ipi.cnpj_produtor }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto_ipi.selo }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_ipi.qtd_selo) }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto_cofins
                        .qtd_total_uni_padrao_tributaca
                    )
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_ipi.vlr) }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto_ipi.vlr_base_calculo
                    )
                  }}
                </td>
                <td>
                  {{
                    formatNumber(
                      rowData.doc_fiscal_imposto_ipi.vlr_unidade_tributaria
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_fiscal_imposto_importacao"
          >
            <thead>
              <tr>
                <th style="width: 20%">Importação</th>
                <th style="width: 20%">Valor Aduaneira</th>
                <th style="width: 20%">Valor BC</th>
                <th style="width: 20%">Valor Imposto</th>
                <th style="width: 20%">Valor IOF</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td></td>
                <td>
                  {{
                    formatNumber(rowData.doc_fiscal_imposto_ipi.vlr_aduaneira)
                  }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_ipi.vlr_bc) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_ipi.vlr_imposto) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_ipi.vlr_iof) }}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_fiscal_imposto_issqn"
          >
            <thead>
              <tr>
                <th style="width: 5%">ISSQN</th>
                <th style="width: 10%">Município</th>
                <th style="width: 5%">Tributação</th>
                <th style="width: 20%">Alíquota</th>
                <th style="width: 20%">Item Lista de Serviço</th>
                <th style="width: 20%">Valor</th>
                <th style="width: 20%">Valor BC</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td></td>
                <td>
                  {{ rowData.doc_fiscal_imposto_issqn.cd_municipio }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto_issqn.cd_tributacao }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_issqn.alq) }}
                </td>
                <td>
                  {{ rowData.doc_fiscal_imposto_issqn.item_lista_servico }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_issqn.vlr) }}
                </td>
                <td>
                  {{ formatNumber(rowData.doc_fiscal_imposto_issqn.vlr_bc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
            role="tabpanel"
            class="tab-pane fade pt-1 border-color-detalhes-grey"
            v-bind:id="'t21' + rowData.docfis_id + ''"
            v-if="
            rowData.doc_fiscal_log.length > 0
          "
        >
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th data-toggle="true" style="width: 80%">Descrição</th>
              <th data-toggle="true" style="width: 10%">Data Primeira e Ultima Ocorrencia</th>
            </tr>
            </thead>
            <tbody
                v-if="rowData.doc_fiscal_log.length > 0"
                v-for="item in rowData.doc_fiscal_log"
            >
            <tr class="bg-gray-light" style="display: table-row">
              <td>
                {{ item.descr }}
              </td>
              <td>
                {{ formatDateHora(item.dt_primeira_ocorrencia) }}<br/>
                {{ formatDateHora(item.dt_ultima_ocorrencia) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div
            role="tabpanel"
            class="tab-pane fade pt-1 border-color-detalhes-grey"
            v-bind:id="'t22' + rowData.docfis_id + ''"
            v-if="
            rowData.usuario_id_ocultar
          "
        >
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th data-toggle="true" style="width: 50%">Usuário</th>
              <th data-toggle="true" style="width: 50%">Data</th>
            </tr>
            </thead>
            <tbody
                v-if="rowData.usuario_id_ocultar"
            >
             <tr class="bg-gray-light" style="display: table-row">
              <td>
                {{ rowData.usuario_ocultar.email }}
              </td>
              <td>
                {{ formatDateHora(rowData.dt_ocultar) }}<br/>
              </td>
             </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t20' + rowData.docfis_id + ''"
          v-if="rowData.doc_fiscal_transporte"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Modalidade</th>
                <th style="width: 10%">Nome</th>
                <th style="width: 10%">CNPJ</th>
                <th style="width: 5%">CPF</th>
                <th style="width: 5%">IE</th>
                <th style="width: 5%">UF</th>
                <th style="width: 5%">Município</th>
                <th style="width: 10%">Endereço</th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                  style="width: 5%"
                >
                  Município Gerador
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                  style="width: 5%"
                >
                  CFOP
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                  style="width: 5%"
                >
                  Alíquota Retenção
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                  style="width: 5%"
                >
                  BC ICMS Retenção
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                  style="width: 5%"
                >
                  ICMS Retido
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                  style="width: 5%"
                >
                  Valor Serviço
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_veiculo > 0
                  "
                  style="width: 5%"
                >
                  Placa
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_veiculo > 0
                  "
                  style="width: 5%"
                >
                  RNTRC
                </th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_veiculo > 0
                  "
                  style="width: 5%"
                >
                  UF Veículo
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.doc_fiscal_transporte.modalidade_frete }}
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.nome
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.cnpj
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.cpf
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.ie
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.uf
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.municipio
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor !== null
                    "
                  >
                    {{
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_transpor.endereco
                    }}
                  </span>
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                >
                  {{
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto
                      .cd_municipio_fato_gerador
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                >
                  {{
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto
                      .cfop
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                >
                  {{
                    formatNumber(
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_imposto.vlr_alq_retencao
                    )
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                >
                  {{
                    formatNumber(
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_imposto.vlr_bc_retencao_icms
                    )
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                >
                  {{
                    formatNumber(
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_imposto.vlr_icms_retido
                    )
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_imposto > 0
                  "
                >
                  {{
                    formatNumber(
                      rowData.doc_fiscal_transporte
                        .doc_fiscal_transporte_imposto.vlr_servico
                    )
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_veiculo > 0
                  "
                >
                  {{
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo
                      .placa
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_veiculo > 0
                  "
                >
                  {{
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo
                      .rntrc
                  }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte
                      .doc_fiscal_transporte_veiculo > 0
                  "
                >
                  {{
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo
                      .uf
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume[0]"
          >
            <thead>
              <tr>
                <th style="width: 10%">Quantidade Volume</th>
                <th style="width: 10%">Espécie Volume</th>
                <th style="width: 10%">Numeração Volume</th>
                <th style="width: 10%">Marca</th>
                <th style="width: 10%">Peso Bruto</th>
                <th style="width: 10%">Peso Líquido</th>
                <th
                  v-if="
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume
                      .doc_fiscal_transporte_vol_lacr > 0
                  "
                  style="width: 10%"
                >
                  Número Lacre
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_transporte
                  .doc_fiscal_transporte_volume"
              >
                <td>
                  {{ formatNumber(item.qtd_volume) }}
                </td>
                <td>
                  {{ item.especie_volume }}
                </td>
                <td>
                  {{ item.numeracao_volume }}
                </td>
                <td>
                  {{ formatNumber(item.marca_volume) }}
                </td>
                <td>
                  {{ formatNumber(item.peso_bruto) }}
                </td>
                <td>
                  {{ formatNumber(item.peso_liquido) }}
                </td>
                <td
                  v-if="
                    rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume
                      .doc_fiscal_transporte_vol_lacr > 0
                  "
                >
                  {{ item.doc_fiscal_transporte_vol_lacr.num_lacre }}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table-striped"
            id="mais"
            v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_reboque"
          >
            <thead>
              <tr>
                <th style="width: 20%">Placa</th>
                <th style="width: 20%">UF</th>
                <th style="width: 20%">RNTRC</th>
                <th style="width: 20%">Vagão</th>
                <th style="width: 20%">Balsa</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.doc_fiscal_transporte
                  .doc_fiscal_transporte_reboque[0]"
              >
                <td>
                  {{ item.placa }}
                </td>
                <td>
                  {{ item.uf }}
                </td>
                <td>
                  {{ item.rntrc }}
                </td>
                <td>
                  {{ item.vagao }}
                </td>
                <td>
                  {{ item.balsa }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
    <!--.tabs-section-nav-->
  </div>
</template>
<script>
import moment from "moment";
import accounting from "accounting";
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick(event) {},
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2);
    },
    formatDate(value, fmt = "D/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
          ? ""
          : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
    },
  }
};
</script>
